import React from 'react';
import { getDecodedToken, landingPage } from '../service/service';
import { Navigate, useLocation } from 'react-router-dom';
import { usePepwiseAuthController } from 'Context/contexts/AuthContext';
import { RESTRICTED_ROLE_NAMES, RESTRICTED_ROUTES_FOR_PwC } from './common-util';
import { checkRole } from './roleUtils';

function PrivateRoute(props: any) {
	const { Component, restrictedRoles, componentProps, requiredCapability } = props;
	const auth = getDecodedToken();
	const location = useLocation();
	const [controller] = usePepwiseAuthController();
  const { role, capabilities } = controller;

  	if (auth && (role === null || role === undefined)) {
		return null; 
	}
	
  	const isRestrictedRoleRoute = checkRole(restrictedRoles, RESTRICTED_ROLE_NAMES);
	const hasPwCRole = checkRole(role, RESTRICTED_ROLE_NAMES);
	const isRestrictedUrl = RESTRICTED_ROUTES_FOR_PwC.includes(location.pathname);
	const isPwcRestricted = isRestrictedRoleRoute && hasPwCRole && isRestrictedUrl;

	const isSystemUser = Array.isArray(role)
		? role.some((r: any) => (typeof r === 'string' ? r : r?.name)?.toLowerCase() === 'pepwise system user')
		: (typeof role === 'string' && role.toLowerCase() === 'pepwise system user');

	const isCapabilityRestricted = Boolean(
		requiredCapability &&
		!isSystemUser &&
		Array.isArray(capabilities) &&
		!capabilities.includes(requiredCapability)
	);

	if (!auth || restrictedRoles?.includes(role) || isPwcRestricted || isCapabilityRestricted) {
		// Store the current URL in localStorage if not authenticated
		if(!isPwcRestricted && !isCapabilityRestricted) localStorage.setItem('redirectAfterLogin', window.location.href);
		// Redirect to the login page or role-specific landing page
		return <Navigate to={landingPage[role] || '/'} state={{ from: location }} />;
	}

	return <Component {...componentProps}/>;
}

export default PrivateRoute;
